import { useState, useEffect } from 'react';

const useInternetConnection = (checkInterval = 5000, latencyThreshold = 300) => {
  const [isConnectionSlow, setIsConnectionSlow] = useState(false); // If connection is slow (true/false)
  const [pingLatency, setPingLatency] = useState<number | null | string>(null);            // Current ping value (ms or error)
  const [consecutiveSlowCount, setConsecutiveSlowCount] = useState(0); // How many slow pings in a row

  // Function to test the ping
  const testPing = async () => {
    try {
      const start = Date.now();
      // HEAD request to avoid downloading body
      await fetch("https://www.google.com", { method: 'HEAD', cache: 'no-cache', mode: 'no-cors' });
      const latency = Date.now() - start;

      setPingLatency(latency as number); // Save current ping latency

      if (latency > latencyThreshold) {
        // If ping is too high, increment slow count
        setConsecutiveSlowCount((prev) => prev + 1);
      } else {
        // If ping is OK, reset slow count
        setConsecutiveSlowCount(0);
      }
    } catch (error) {
      // Treat errors as slow connection
      setPingLatency('Error');
      setConsecutiveSlowCount((prev) => prev + 1);
    }
  };

  // Monitor consecutive slow pings to set connection status
  useEffect(() => {
    if (consecutiveSlowCount >= 2) {
      // console.log('⚠️ Connection is SLOW (based on 2 consecutive bad pings)');
      setIsConnectionSlow(true); // Two or more bad pings -> show message
    } else {
      // if (isConnectionSlow) {
      //   console.log('✅ Connection is back to normal');
      // }
      setIsConnectionSlow(false); // Less than two -> hide message
    }
  }, [consecutiveSlowCount]);

  // Ping loop that runs as long as component is mounted
  useEffect(() => {
    const interval = setInterval(testPing, checkInterval); // Run ping every X ms

    return () => clearInterval(interval); // Cleanup when component unmounts
  }, [checkInterval]);

  // Return the connection status and ping latency (if you want to display it)
  return { isConnectionSlow, pingLatency };
};

export default useInternetConnection;